import { useSelector } from 'react-redux';

const useIsLtiUser = () => {
    return useSelector(state => state.isLti);
};

export default useIsLtiUser;
